module.exports = require('./ProductTabsComponent');